import { IResetPasswordDTO } from '@/models/auth.model';
import { AuthFieldsNames, TResetPasswordFormValues } from '../helpers/types';

class ResetPasswordDTO implements IResetPasswordDTO {
  email;
  token;
  password;
  password_confirmation;

  constructor(values: TResetPasswordFormValues & { email: string; token: string }) {
    this.email = values.email;
    this.token = values.token;
    this.password = values[AuthFieldsNames.PASSWORD];
    this.password_confirmation = values[AuthFieldsNames.CONFIRM_PASSWORD];
  }
}

export default ResetPasswordDTO;
